import { addToHTMLList } from './addToHTMLList'
import { pageId, isMeasurementBookEditUrl } from '../../fromPhp'
import { iconFile } from '../icons'

export const addOldFilesToHTMLList = () => {
  const url = isMeasurementBookEditUrl()
    ? '/api/mbook/pageFiles/' + pageId()
    : '/api/pageFiles/' + pageId()
  fetch(url)
    .then(response => response.json())
    .then(fileInfos => output(fileInfos))
}

/**
 * @typedef FileInfo
 * @property {string} name
 * @property {string} path
 * @property {number} id File instance id in database. Used for file removal
 */

/**
 * @param {FileInfo[]} fileInfos 
 */
const output = (fileInfos) => {
  fileInfos.forEach(fileInfo => {
    addToHTMLList(fileInfo.name, fileInfo.path, fileInfo.id, iconFile, false)
  })
}